var version = {
    "name":      "dativery",
    "buildDateCode": "20260917-083217",
    "buildDate": "Thu Sep 17 2026 08:32:17 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260917-083217",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;